




import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import NewContainer from '@/containers/cv-section-text/new.vue';

import * as CvSectionTextStoreNew from '@/store/modules/cvSectionTextNew';

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook],
  data() {
    return {
      storeList: [CvSectionTextStoreNew],
    };
  },
});
